(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["orlivy-home-styling"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('orlivy-home-styling')) {
  customElements.define('orlivy-home-styling', class extends HTMLElement {
    connectedCallback() {
      queueMicrotask(() => {
        if (this.isConnected) this.initialize();
      });
    }

    disconnectedCallback() {
      this.abortController?.abort();
      this.abortController = null;
    }

    initialize() {
      if (this.abortController) return;
      const tablist = this.querySelector('[data-styling-tabs]');
      const tabs = Array.from(this.querySelectorAll('[data-styling-tab]'));
      const availablePanels = Array.from(this.querySelectorAll('[data-styling-panel]'));
      const panels = tabs.map(tab => availablePanels.find(panel => panel.id === tab.dataset.stylingTarget));
      if (!tablist || !tabs.length || panels.some(panel => !panel)) return;

      this.abortController = new AbortController();
      const { signal } = this.abortController;
      this.tabs = tabs;
      this.panels = panels;
      tablist.setAttribute('role', 'tablist');
      tablist.setAttribute('aria-orientation', 'horizontal');

      tabs.forEach((tab, index) => {
        tab.setAttribute('role', 'tab');
        tab.setAttribute('aria-controls', panels[index].id);
        panels[index].setAttribute('role', 'tabpanel');
        panels[index].setAttribute('aria-labelledby', tab.id);
        const heading = panels[index].querySelector('[data-styling-heading]');
        if (heading) heading.hidden = true;
        tab.addEventListener('click', () => this.activate(index), { signal });
        tab.addEventListener('focus', () => this.activate(index), { signal });
      });

      tablist.addEventListener('keydown', event => {
        const tab = event.target.closest('[data-styling-tab]');
        const currentIndex = tabs.indexOf(tab);
        if (currentIndex < 0) return;
        const direction = getComputedStyle(tablist).direction === 'rtl' ? -1 : 1;
        let nextIndex;
        if (event.key === 'ArrowRight') nextIndex = (currentIndex + direction + tabs.length) % tabs.length;
        if (event.key === 'ArrowLeft') nextIndex = (currentIndex - direction + tabs.length) % tabs.length;
        if (event.key === 'Home') nextIndex = 0;
        if (event.key === 'End') nextIndex = tabs.length - 1;
        if (nextIndex === undefined) return;
        event.preventDefault();
        this.activate(nextIndex, true);
      }, { signal });

      this.addEventListener('shopify:block:select', event => {
        const panel = event.target.closest('[data-styling-panel]');
        const index = panels.indexOf(panel);
        if (index >= 0) this.activate(index);
      }, { signal });

      this.activate(0);
      tablist.hidden = false;
    }

    activate(index, moveFocus = false) {
      this.tabs.forEach((tab, tabIndex) => {
        const selected = tabIndex === index;
        tab.setAttribute('aria-selected', String(selected));
        tab.tabIndex = selected ? 0 : -1;
        this.panels[tabIndex].hidden = !selected;
      });
      if (moveFocus) this.tabs[index].focus();
    }
  });
}
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["variant-picker"] && !Shopify.designMode) return;
  try {
    // Keep a pointer selection from scrolling the hidden radio behind the sticky header.
document.addEventListener('click', event => {
  const label = event.target.closest?.('variant-picker[update-url] label[for]');
  if (label?.control?.type === 'radio' && !label.control.disabled) {
    label.control.focus({ preventScroll: true });
  }
}, true);
  } catch(e) { console.error(e); }
})();

})();
